// src/components/HeroSection.jsx

import React from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import bannerColored from '../Assets/Additional-images/banner-colored-lenses.jpeg';
import bannerClear from '../Assets/Additional-images/banner-clear-lenses.jpeg';

function Arrow({ onClick, side }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={side === 'next' ? 'Next slide' : 'Previous slide'}
      className={`absolute top-1/2 -translate-y-1/2 z-20 ${side === 'next' ? 'right-3 sm:right-5' : 'left-3 sm:left-5'}
        w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-ink/55 hover:bg-brand-500 text-cream hover:text-ink
        backdrop-blur-sm flex items-center justify-center transition-colors`}
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        {side === 'next' ? <path d="M9 6l6 6-6 6" /> : <path d="M15 6l-6 6 6 6" />}
      </svg>
    </button>
  );
}

const HeroSection = () => {
  const navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    arrows: true,
    nextArrow: <Arrow side="next" />,
    prevArrow: <Arrow side="prev" />,
  };

  const slides = [
    { image: bannerColored, alt: "Colored contact lenses collection", to: "/products/colored-lenses" },
    { image: bannerClear,   alt: "Clear contact lenses — free delivery", to: "/products/clear-lenses" },
  ];

  return (
    <section className="relative bg-ink overflow-hidden">
      <Slider {...settings}>
        {slides.map((slide, i) => (
          <div key={i}>
            {/* Full banner at natural aspect — no crop, no zoom, on every screen size */}
            <img
              src={slide.image}
              alt={slide.alt}
              onClick={() => navigate(slide.to)}
              className="w-full h-auto block cursor-pointer"
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroSection;
